import { Link } from 'react-router-dom';
import { PageShell } from '../components/PageShell';
import { GlassPanel } from '../components/GlassPanel';
import { MaterialIcon } from '../components/MaterialIcon';
import { MobileBottomNav } from '../components/MobileBottomNav';

export default function HowToPlayPage() {
  return (
    <PageShell mainClassName="mt-20 px-margin-mobile md:px-margin-desktop max-w-5xl mx-auto space-y-stack-lg pb-24 min-h-screen">
      <section className="py-8 text-center md:text-left">
        <h1 className="font-display-lg text-display-lg text-primary mb-2">How to Play</h1>
        <p className="text-on-surface-variant font-body-lg">Master the art of nocturnal chaos and provocative wit.</p>
      </section>

      <div className="grid grid-cols-1 md:grid-cols-6 gap-gutter">
        <GlassPanel className="md:col-span-3 rounded-xl p-stack-lg overflow-hidden relative group">
          <div className="relative z-10">
            <div className="w-12 h-12 bg-surface-container-highest rounded-lg flex items-center justify-center mb-stack-md border border-white/5">
              <MaterialIcon name="style" className="text-primary" />
            </div>
            <h3 className="font-headline-md-mobile text-headline-md-mobile text-on-surface mb-2">1. Black Cards</h3>
            <p className="text-on-surface-variant mb-4">
              Every round begins with a Black Card. This is the setup, the prompt, or the fill-in-the-blank question that
              everyone else must answer.
            </p>
            <div className="bg-black border border-white/20 rounded-lg p-4 max-w-[240px] transform -rotate-2 shadow-xl">
              <p className="font-card-text text-card-text text-white">
                Before I was famous, I was just a regular person doing _________.
              </p>
            </div>
          </div>
        </GlassPanel>

        <GlassPanel className="md:col-span-3 rounded-xl p-stack-lg overflow-hidden relative group">
          <div className="relative z-10">
            <div className="w-12 h-12 bg-white rounded-lg flex items-center justify-center mb-stack-md shadow-lg shadow-white/5">
              <MaterialIcon name="layers" className="text-black" />
            </div>
            <h3 className="font-headline-md-mobile text-headline-md-mobile text-on-surface mb-2">2. White Cards</h3>
            <p className="text-on-surface-variant mb-4">
              You hold a hand of White Cards — your secret arsenal of responses. Play the one you think will make the
              Judge laugh the hardest.
            </p>
            <div className="flex gap-2 transform translate-x-4">
              <div className="bg-white border border-black/10 rounded-lg p-4 w-32 h-44 shadow-xl -rotate-6">
                <p className="text-xs font-bold text-black mb-1">DECK AFTER DARK</p>
                <p className="font-card-text text-sm leading-tight text-black">A suspiciously large wooden horse.</p>
              </div>
              <div className="bg-white border border-black/10 rounded-lg p-4 w-32 h-44 shadow-xl rotate-3">
                <p className="text-xs font-bold text-black mb-1">DECK AFTER DARK</p>
                <p className="font-card-text text-sm leading-tight text-black">Grandma&apos;s special brownies.</p>
              </div>
            </div>
          </div>
        </GlassPanel>

        <div className="md:col-span-2 holographic-border rounded-xl overflow-hidden group">
          <div className="holographic-content p-stack-lg flex flex-col h-full">
            <div className="w-12 h-12 bg-primary/20 rounded-lg flex items-center justify-center mb-stack-md border border-primary/30">
              <MaterialIcon name="edit" className="text-primary" filled />
            </div>
            <h3 className="font-label-bold text-label-bold text-primary uppercase tracking-widest mb-2">Pro Move</h3>
            <h3 className="font-headline-md-mobile text-headline-md-mobile text-on-surface mb-2">3. Wild Cards</h3>
            <p className="text-on-surface-variant text-sm">
              Got a better idea? Use a Wild Card to write your own answer and inject pure chaos into the round.
            </p>
          </div>
        </div>

        <GlassPanel className="md:col-span-2 rounded-xl p-stack-lg relative overflow-hidden">
          <div className="w-12 h-12 bg-secondary/20 rounded-lg flex items-center justify-center mb-stack-md border border-secondary/30">
            <MaterialIcon name="gavel" className="text-secondary" />
          </div>
          <h3 className="font-headline-md-mobile text-headline-md-mobile text-on-surface mb-2">4. Judging</h3>
          <p className="text-on-surface-variant text-sm">
            The Card Czar for the round reviews all submissions blindly and picks the winner. No bias, just laughs.
          </p>
          <div className="absolute bottom-4 right-4 flex items-center gap-2">
            <span className="relative flex h-3 w-3">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-secondary opacity-75" />
              <span className="relative inline-flex rounded-full h-3 w-3 bg-secondary" />
            </span>
            <span className="text-xs font-label-bold text-secondary uppercase">Active Judge</span>
          </div>
        </GlassPanel>

        <div className="md:col-span-2 bg-primary/10 border border-primary/20 rounded-xl p-stack-lg relative">
          <div className="w-12 h-12 bg-primary rounded-lg flex items-center justify-center mb-stack-md shadow-lg shadow-primary/20">
            <MaterialIcon name="emoji_events" className="text-on-primary" filled />
          </div>
          <h3 className="font-headline-md-mobile text-headline-md-mobile text-on-surface mb-2">5. Winning</h3>
          <p className="text-on-surface-variant text-sm">
            Winning a round grants you a point. The player with the most points at the end of the game wins the night!
          </p>
        </div>
      </div>

      <section className="flex flex-col items-center justify-center py-12 gap-stack-md">
        <Link
          to="/"
          className="px-10 py-4 bg-primary text-on-primary font-label-bold rounded-lg hover:scale-105 active:scale-95 transition-all neon-glow-primary flex items-center gap-2"
        >
          <MaterialIcon name="arrow_back" />
          Back to Home
        </Link>
        <p className="text-on-surface-variant text-sm opacity-60">Ready to play? The lobby is waiting.</p>
      </section>
      <MobileBottomNav />
    </PageShell>
  );
}
